 
  <div class="tabs-container">
    <div class="card">
      <ion-row *ngIf="!router.url.includes('Setup')">
        <ion-col size-sm="10" size-md="7" size-lg="7" size-xs="10" class="pl-15 pr-0 pb-0">
          <div class="" *ngIf="!router.url.includes('Setup')">
            <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
              (selectedTabChange)="tabTypeChanged($event)">
              <mat-tab label="createcalendar">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                   Create Calendar</span>
                </ng-template>
              </mat-tab>
              <mat-tab label="employeeapproval">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                   Employee Approval
                    </span>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </div>
        </ion-col>
       
      </ion-row>
    </div>
    
    
    <div class="card  createcalendar">

      <!-- Create calendar -->
       
      <div class="p-10 m-20 createcalendar"  *ngIf="selectedTypeTabName=='createcalendar'">
       <div>
        <button type="button" class="add_btn fs-14 mr-15"
        style="display: flex;float: right; margin-bottom:10px; align-items: center"
        [style.background-color]="buttonColorName" (click)="onClickAddNewProgramPopup()">
        + Add Programme</button>
       </div>
        <div class="table-container">
          <table class="custom-table rounded-header">
             <thead>
              <tr>
                
                 <th *ngFor="let item of tableHeaders"
                  class="fs-14 font_bold cl-black">
                  <div class=" verticle-center justify-content-space-between icon-style">
                    {{ item?.label }}
                  </div>
                 </th>
              </tr>
            </thead>
              <tbody class="bg-white">
                <tr *ngFor="let program of trainingPrograms">
                  
                  <td>{{ program.trainingType }}</td>
                  <td>{{ program.title }}</td>
                  <td>{{ program.code }}</td>
                  <td><a [href]="program.lmsLink" target="_blank">link</a></td>
                  <td>{{ program.startDate }}</td>
                  <td>{{ program.endDate }}</td>
                  <td>{{ program.category }}</td>
                  <td>{{ program.department }}</td>
                  <td>{{ program.band }}</td>
                  <td>{{ program.grade }}</td>
                  <td>{{ program.location }}</td>
                  <td>{{ program.programDays }}</td>
                  <td>{{ program.budgetCost }}</td>
                  <td>{{ program.actualCost }}</td>
                  <td><a (click)="facultyNamePopup()">{{ program.facultyname }}</a></td>
                  <td>{{ program.objective }}</td>
                  <td>
                    <img class="mr-5 cp imgdelete" title="Edit" src="././assets/icon/edit.png"
                    (click)="editProgram()" width="25px" >

                    <span class="material-icons fs-20 red cp"  (click)="deleteProgram()"
                     >delete</span>
                  </td>
                </tr>
              </tbody>
          </table>
        </div>
        <div class="mt-10" style="font-weight: bold;">
         <!-- {{autorityListData.length}} entries -->
        </div>
      </div>





      <!-- Employee Approval -->


            <div class="p-10 m-20"   *ngIf="selectedTypeTabName=='employeeapproval'" >      
              <form [formGroup]="programForm">
                <ion-row class="center-content">
                  <ion-col size-sm="3" size-md="9" size-lg="2" size-xs="10" class="mb-10">
                    <div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <mat-select placeholder="Select" formControlName="selectedProgram">
                          <mat-option *ngFor="let program of programList" [value]="program">
                            {{ program }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </ion-col>         
                </ion-row>
              </form> 
            <div class="table-container">
              <table class="custom-table rounded-header">
                 <thead>
                  <tr>
                    <ng-container *ngFor="let item of tableHeaders">
                      <th *ngIf="item.label !== 'Action'" class="fs-14 font_bold cl-black">
                        <div class="verticle-center justify-content-space-between icon-style">
                          {{ item?.label }}
                        </div>
                      </th>
                    </ng-container>
                  </tr>
                </thead>
                  <tbody class="bg-white">
                    <tr *ngFor="let program of trainingPrograms">
                     <td>{{ program.trainingType }}</td>
                      <td>{{ program.title }}</td>
                      <td>{{ program.code }}</td>
                      <td><a [href]="program.lmsLink" target="_blank">link</a></td>
                      <td>{{ program.startDate }}</td>
                      <td>{{ program.endDate }}</td>
                      <td>{{ program.category }}</td>
                      <td>{{ program.department }}</td>
                      <td>{{ program.band }}</td>
                      <td>{{ program.grade }}</td>
                      <td>{{ program.location }}</td>
                      <td>{{ program.programDays }}</td>
                      <td>{{ program.budgetCost }}</td>
                      <td>{{ program.actualCost }}</td>
                      <td>{{ program.facultyname }}</td>
                      <td>{{ program.objective }}</td>
                    </tr>
                  </tbody>
              </table>
            </div>
            
        
            <!-- Employee approve/reject -->
        
          <div class="mt-10" style="font-weight: bold; margin-top: 45px !important;">
            <div class="table-container">
              <div class="mb-10">
                <button type="button" class="add_btn fs-14"
                [style.background-color]="buttonColorName" (click)="approveSelected()">Approve</button>
                <button type="button" class="add_btn fs-14"
                [style.background-color]="buttonColorName" (click)="rejectSelected()">Reject</button>
              </div>
              <table class="custom-table rounded-header">
                <thead>
                  <tr>
                    <th class="fs-14 font_bold cl-black">
                      <mat-checkbox  color="primary" (change)="selectAll($event)"></mat-checkbox>
                    </th>
                    <th *ngFor="let item of employeeTableHeaders" class="fs-14 font_bold cl-black">
                      <div class="verticle-center justify-content-space-between icon-style">
                        {{ item?.label }}
                      </div>
                    </th>
                  </tr>
                </thead>
            
                <tbody class="bg-white">
                  <tr *ngFor="let program of employeeTrainingPrograms">
                    <td>
                      <mat-checkbox  color="primary" [(ngModel)]="program.selected"></mat-checkbox>
                    </td>
            
                    <td>{{ program.code }}</td>
                    <td>{{ program.name }}</td>
                    <td>{{ program.department }}</td>
                    <td>{{ program.band }}</td>
                    <td>{{ program.grade }}</td>
                    <td>{{ program.nominatedBy }}</td>
                    <td>{{ program.status }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            
          </div>
        </div>



    </div>
 



    </div>

 
 